import { AutogenModelPnnZoneReply, AutogenRowPnnZoneReply } from "./autogen/AutogenModelPnnZoneReply";

export class ModelPnnZoneReply extends AutogenModelPnnZoneReply<RowPnnZoneReply> {
	constructor() {
		super(RowPnnZoneReply);
	}
}

export class RowPnnZoneReply extends AutogenRowPnnZoneReply {
}